import React from "react";
import {getPackageUID, PACKAGE_STATES} from "../../../../lib/WarehouseHelper";
import {updatePackages} from "../../../../actions/WarehousePackageActions";
import {useDispatch} from "react-redux";
import {graphql} from "react-apollo";
import {compose} from "redux";
import ActionButton from "../../../../components/ActionButton";
import {START_BATCH_PICKING} from "../../../../queries/warehouseJobs";


// Idle is the first state, and the only possible action is to start a batch
// with any number of jobs.
const IdleActions = (props) => {
  const { warehouseId, jobIds, packages, afterClick } = props;

  const dispatch = useDispatch();

  if (!jobIds) {
    // Only action available in this state is about job ids
    return null;
  }
  
  const handleStart = (jobIdsToStart) => {
    // Update packages in the reducer
    const packageUIds = packages.filter((p) => jobIdsToStart.includes(p.get("jobId"))).map((p) => getPackageUID(p)).toJS();
    dispatch(updatePackages(warehouseId, packageUIds, (p) => p.set("state", PACKAGE_STATES.PICK)));
    // Send mutation to server
    props.startBatchPicking(warehouseId, jobIdsToStart);

    if (afterClick) {
      afterClick();
    }
  }

  return (
    <ActionButton
      onClick={() => handleStart(jobIds)}
      active={jobIds.size > 0}
      label="Create Picking Batch"
    />
  );
}

const withQuery = compose(
  graphql(START_BATCH_PICKING, {
    props: ({ mutate }) => ({
      startBatchPicking: (warehouseId, jobIds) => mutate({
        variables: { data: { warehouseId, jobIds } }
      })
    })
  })
);

export default withQuery(IdleActions);